// import Offcanvas from 'react-bootstrap/Offcanvas';
import { useEffect, useMemo, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { MdOutlineLogout } from "react-icons/md";
import { IoSettingsOutline } from "react-icons/io5";
import { RiDeleteBinLine } from "react-icons/ri";
import { MdOutlineDashboard } from "react-icons/md";
import { TbBriefcase2 } from "react-icons/tb";
import LocationIcon from "@/../../public/images/locationIcon.svg";
import SearchIcon from "@/../../public/images/search.svg";
import BriefcaseIcon from "@/../../public/images/lucide_briefcase-business.svg";
import LogoImg from "@/../../public/images/pelorus-logo.svg";

// import Collapse from 'react-bootstrap/Collapse';
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { AppRoute } from "../../router/routerConstants";
import { logOut } from "../../store/auth.store";
import { useDispatch } from "react-redux";
import { clearAllStorage } from "../../utils/Common";
import AccountDeleteModal from "../../common/account-delete-modal";
import { clearNotifications } from "../../store/notification.store";
import { clearChatData } from "../../store/chat.store";
import { BsBriefcase } from "react-icons/bs";

const EmployerSidebarScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);
  const handleShowWK = () => setShowWork(true);

  const [showdell, setShowdell] = useState(false);
  const handleCloseDL = () => setShowdell(false);
  const handleShowDl = () => setShowdell(true);

  const [activeMenu, setActiveMenu] = useState("dashboard");

  const sidebarMenuConfig = useMemo(
    () => [
      {
        key: "dashboard",
        label: "Dashboard",
        icon: <MdOutlineDashboard />,
        route: AppRoute.EMPLOYER_DASHBOARD,
      },
      {
        key: "postJob",
        label: "Post A Job",
        icon: <BsBriefcase />,
        route: AppRoute.EMPLOYER_POST_JOB,
      },
      {
        key: "manageJobs",
        label: "Manage Jobs",
        icon: <TbBriefcase2 />,
        route: AppRoute.EMPLOYER_MANAGE_JOBS,
        childRoute: AppRoute.EMPLOYER_APPLICANTS,
      },
      {
        key: "settings",
        label: "Settings",
        icon: <IoSettingsOutline />,
        route: AppRoute.EMPLOYER_SETTINGS,
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
    ],
    []
  );

  const logoutAction = () => {
    dispatch(logOut());
    clearAllStorage();
    handleCloseWK();
    dispatch(clearNotifications());
    dispatch(clearChatData());
  };

  const handleMenuClick = (menuKey: string, route: string) => {
    setActiveMenu(menuKey);
    NavigateTo(route);
  };

  useEffect(() => {
    const currentPath = window.location.pathname;
    const activeItem = sidebarMenuConfig.find(
      (menu) => menu.route === currentPath || menu.childRoute === currentPath
    );
    if (activeItem) {
      setActiveMenu(activeItem.key);
    }
  }, [sidebarMenuConfig]);

  return (
    <>
      <div className="leftsidebar">
        <div className="logo">
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={() => NavigateTo(AppRoute.SPLASH)}
            style={{ cursor: "pointer" }}
          >
            <img src={LogoImg} alt="logo" />
          </a>
        </div>
        <div className="leftsidebar-holder">
          <div className="sidebarmenu">
            <ul>
              {sidebarMenuConfig &&
                sidebarMenuConfig?.map((menu) => (
                  <li
                    key={menu.key}
                    className={activeMenu === menu.key ? "active" : ""}
                  >
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => handleMenuClick(menu.key, menu.route)}
                    >
                      {menu.icon} {menu.label}
                    </a>
                  </li>
                ))}
              <li>
                <Button variant="primary" onClick={handleShowDl}>
                  {" "}
                  <RiDeleteBinLine /> Delete Account
                </Button>
              </li>
            </ul>
          </div>
          <Button className="btn logout" type="button" onClick={handleShowWK}>
            {" "}
            <MdOutlineLogout /> Log Out
          </Button>
        </div>
      </div>

      {/* 
            <Button variant="primary" onClick={ddhandleShow}>Launch</Button>
            <Offcanvas show={showoffcanvas} onHide={offhandleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                </Offcanvas.Body>
            </Offcanvas>*/}

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="findbody">
            <h3>Find A Job</h3>
            <Form className="modalSearch">
              <Form.Group className="iconinside mb-3">
                <div className="icon">
                  <img src={BriefcaseIcon} alt="Briefcase Icon" />
                </div>
                <Form.Control type="text" placeholder="Industry" />
              </Form.Group>
              <Form.Group className=" iconinside mb-3">
                <div className="icon">
                  <img src={LocationIcon} alt="Location Icon" />
                </div>
                <Form.Control type="text" placeholder="Location" />
              </Form.Group>
              <Button className="btn btn-black w-100" type="submit">
                {" "}
                <img src={SearchIcon} alt="Search Icon" /> Search
              </Button>
            </Form>
          </div>
          <div className="ppsrch">
            <h6>Popular Searched:</h6>
            <ul>
              <li>
                <span>Accountancy</span>
              </li>
              <li>
                <span>Marketing & PR </span>
              </li>
              <li>
                <span>Healthcare</span>
              </li>
              <li>
                <span>New York</span>
              </li>
              <li>
                <span>Paris</span>
              </li>
              <li>
                <span>Germany</span>
              </li>
            </ul>
          </div>
        </Modal.Body>
      </Modal>

      {/* Log Out model*/}
      <Modal
        show={showWork}
        onHide={handleCloseWK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <Form className="logoutmdl">
              <div className="logouticon">
                <MdOutlineLogout />
              </div>
              <h3>Log Out</h3>
              <p>Are you sure you want to log out?</p>
              <p>
                You will need to log in again to access your account and view
                your job applications, notifications, and profile.
              </p>
              <div className="d-flex gp-10">
                <Button
                  className="btn btn-black w-100"
                  type="button"
                  onClick={handleCloseWK}
                >
                  Cancel
                </Button>
                <Button
                  className="btn w-100"
                  type="button"
                  onClick={logoutAction}
                >
                  Log Out
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Log Out model*/}
      {/* Delete Account model*/}
      <AccountDeleteModal show={showdell} onHide={handleCloseDL} />
      {/* <Modal
        show={showdell}
        onHide={handleCloseDL}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <Form className="logoutmdl">
              <div className="logouticon">
                <RiDeleteBinLine />
              </div>
              <h3>Delete Account</h3>
              <p>Are you sure you want to delete your account?</p>
              <p>
                After deletion, you will no longer be able to access your
                account or recover any information.
              </p>
              <div className="d-flex gp-10">
                <Button className="btn btn-black w-100" type="submit">
                  Cancel
                </Button>
                <Button className="btn btn-black w-100" type="submit">
                  Delete
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal> */}
      {/* Delete Account model*/}
    </>
  );
};
export default EmployerSidebarScreen;
